import React, { useState, useEffect, useCallback } from 'react';
import { ACTIVE_API_BASE_URL } from "../config/apiConfig"
import apiClient from '../api/axiosClient';
import { ChevronLeft, ChevronRight, Save } from 'lucide-react';
import { useNavigate,useLocation } from 'react-router-dom';
import '../styles/FormProduction.css';
import SidebarGuideline from "./SidebarGuideline"
import {downloadFile} from '../common'

// Constants for max lengths
const FIELD_MAX_LENGTH = 100;
const COMPANY_PROFILE_MAX_LENGTH = 300;
const COMMENT_MAX_LENGTH = 200;
const PHONE_MAX_LENGTH = 10;
const INNOVATION_NAME_MAX_LENGTH = 100;
const TEXTAREA_MAX_LENGTH = {
  innovation_description: 300, // innovator1_1
  quantifiable_impact: 200, // innovator1_2
  novelty_uniqueness: 400, // innovator1_3
  scalability: 100, // innovator1_4
  replicability: 100, // innovator1_5
  adaptability: 100, // innovator1_6
  intangible_benefits_hse: 300, // innovator2_1
  carbon_footprint_reduction: 300, // innovator2_2
  quality_compliance: 300, // innovator2_3
  energy_efficiency: 300, // innovator2_4
  external_partnerships: 100, // innovator4_1
  external_recognition: 100, // innovator4_2
};

// Validation regex
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\d{10}$/;
const numberRegex = /^\d*$/;

const RegistrationInnovator = () => {
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(null);
  const awardTitle = location.state?.awardTitle || 'Innovator of the Year (Team)';
  const [userInfo, setUserInfo] = useState();
  const [formId, setFormId] = useState("Unknown");
  const [PkId, setPkId] = useState(0);
  const [disableSave, setDisableSave] = useState(false);

  // Form state initialization
  const [formData, setFormData] = useState({
    Organisationname: '',
    category: 'Innovator of the Year (Team)',
    companyName: '',
    mailingAddress: '',
    authorityName: '',
    authorityTitle: '',
    authorityPhone: '',
    authorityLandline: "",
    authorityEmail: '',
    applicant_name: "",
    applicant_phone: "",
    applicant_email: "",
    contact_name: '',
    contact_phone: '',
    contact_email: '',
    companyProfile: '',
    approvingAuthoritySignature: null,
    declaration: false,
    comment: '',
    innovation_name: '', // Previously innovatortextbox
    // Quantitative fields
    tangible_benefits: '', // innovator1
    innovation_description: '', // innovator1_1
    quantifiable_impact: '', // innovator1_2
    novelty_uniqueness: '', // innovator1_3
    scalability: '', // innovator1_4
    replicability: '', // innovator1_5
    adaptability: '', // innovator1_6
    intangible_impact: '', // innovator2
    intangible_benefits_hse: '', // innovator2_1
    carbon_footprint_reduction: '', // innovator2_2
    quality_compliance: '', // innovator2_3
    energy_efficiency: '', // innovator2_4
    patents: '', // innovator3
    patents_filed: '', // innovator3_1
    patents_granted: '', // innovator3_2
    miscellaneous: '', // innovator4
    external_partnerships: '', // innovator4_1
    external_recognition: '', // innovator4_2
    external_presentation: '', // innovator4_3
    // Team members
    member1: '',
    member2: '',
    member3: '',
    member4: '',
    member5: '',
    // Attachments
    attachments1: { description: '', file: null },
    attachments2: { description: '', file: null },
    attachments3: { description: '', file: null },
    attachments4: { description: '', file: null },
  });



    useEffect(() => {
      try {
        const stored = sessionStorage.getItem("user_info");
        if (stored) {
          const user = JSON.parse(stored);
          setUserInfo(JSON.parse(stored));
          setFormId(`Innovator_Registration_${user.id}`);
  
          setFormData((prev) => ({
            ...prev,
            userid: user.id || "",
            firstname: user.first_name || "",
            lastname: user.last_name || "",
            company_name: user.organisation_name || "",
            Organisationname: user.organisation_name || "",
            applicant_name: user.applicant_name || "",
            applicant_phone: user.applicant_phone || "",
            applicant_email: user.email || "",
          }));
        }
      } catch (err) {
        console.warn("Failed to parse user_info from localStorage:", err);
      }
    }, []);
  
    // This use Effect Prefill user Data using api;
    useEffect(() => {
      console.log("called innovator prefill useEffect");
      if (userInfo) {
        prefillFormData();
      } else {
        console.warn(
          `userInfo OR formId is invalid; Kindly check the method. and data`
        );
      }
    }, [userInfo, formId]);
  
    const isSubmited = () => formData?.form_mode === "submit" || disableSave;
  
    useEffect(() => {}, []);
  
function prefillFormData() {
  const url = `/registration-innovator/?form_id=${formId}`;
  console.log("prefill url:", url);

  apiClient
    .get(url)
    .then((res) => {
      if (!Array.isArray(res.data) || res.data.length !== 1) {
        console.warn("prefill: response not a single item, skipping");
        return;
      }

      const item = res.data[0];
      console.log("prefill: server item:", item);

      // common primary key variants
      setPkId(item.id ?? item.pk ?? item.pk_id ?? 0);

      // possible user object returned by server
      const serverUser =
        item.user ?? item.user_info ?? (item.user_id ? { id: item.user_id } : null);

      // normalize boolean-like values
      const boolish = (v) =>
        v === true || v === "true" || v === "1" || v === 1 || v === "yes";

      const newFields = {
        // ─── Identity / Org Info ─────────────────────────
        Organisationname:
          item.organisation_name ??
          item.organisationName ??
          item.company_name ??
          item.companyName ??
          "",
        category: item.category ?? item.cat ?? "",
        mailingAddress: item.mailing_address ?? item.mailingAddress ?? item.mailing_address_line ?? "",

        // user meta (helpful even if you merge from localStorage on submit)
        userid: item.userid ?? item.user_id ?? (serverUser && serverUser.id) ?? item.created_by ?? "",
        firstname: item.firstname ?? item.first_name ?? (serverUser && serverUser.first_name) ?? "",
        lastname: item.lastname ?? item.last_name ?? (serverUser && serverUser.last_name) ?? "",
        company_name: item.company_name ?? item.companyName ?? item.organisation_name ?? "",

        // ─── Approving Authority ─────────────────────────
        authorityName:
          item.authority_name ?? item.authorityName ?? item.authority ?? "",
        authorityTitle:
          item.authority_title ?? item.authorityTitle ?? item.authority_designation ?? "",
        authorityPhone:
          item.authority_phone ?? item.authorityPhone ?? item.authorityTelephone ?? "",
        authorityLandline:
          item.authority_landline ?? item.authorityLandline ?? item.authority_land_line ?? "",
        authorityEmail:
          item.authority_email ?? item.authorityEmail ?? item.authority_contact_email ?? "",

        // form meta
        form_id: item.form_id ?? item.formId ?? formId ?? "",
        form_mode: item.form_mode ?? item.formMode ?? item.mode ?? "draft",

        // ─── Contact / Nodal Official ────────────────────
        contact_name: item.contact_name ?? item.contactName ?? item.nodal_name ?? "",
        contact_phone: item.contact_phone ?? item.contactPhone ?? item.nodal_phone ?? "",
        contact_email: item.contact_email ?? item.contactEmail ?? item.nodal_email ?? "",

        // ─── Company / Comments ──────────────────────────
        companyProfile: item.company_profile ?? item.companyProfile ?? item.profile_text ?? "",
        declaration: boolish(item.declaration) ?? false,
        comment: item.comment ?? item.notes ?? "",

        // ─── Innovator quantitative fields (model names) ─
        innovation_name: item.innovatortextbox ?? item.innovation_name ??  item.innovation_title ?? item.innovator_text ?? "",
        innovator1: item.innovator1 ?? item.innovator_1 ?? item.tangible_benefits ?? item.tangibleBenefits ?? "",
        innovator1_1: item.innovator1_1 ?? item.innovator_1_1 ?? item.innovation_description ?? item.innovationDescription ?? "",
        innovator1_2: item.innovator1_2 ?? item.innovator_1_2 ?? item.quantifiable_impact ?? item.quantifiableImpact ?? "",
        innovator1_3: item.innovator1_3 ?? item.innovator_1_3 ?? item.novelty_uniqueness ?? item.noveltyUniqueness ?? "",
        innovator1_4: item.innovator1_4 ?? item.innovator_1_4 ?? item.scalability ?? item.scalability_notes ?? "",
        innovator1_5: item.innovator1_5 ?? item.innovator_1_5 ?? item.replicability ?? item.replicability_notes ?? "",
        innovator1_6: item.innovator1_6 ?? item.innovator_1_6 ?? item.adaptability ?? item.adaptability_notes ?? "",

        innovator2: item.innovator2 ?? item.innovator_2 ?? item.intangible_impact ?? item.intangibleImpact ?? "",
        innovator2_1: item.innovator2_1 ?? item.innovator_2_1 ?? item.intangible_benefits_hse ?? item.intangibleBenefitsHSE ?? "",
        innovator2_2: item.innovator2_2 ?? item.innovator_2_2 ?? item.carbon_footprint_reduction ?? item.carbonReduction ?? "",
        innovator2_3: item.innovator2_3 ?? item.innovator_2_3 ?? item.quality_compliance ?? item.qualityCompliance ?? "",
        innovator2_4: item.innovator2_4 ?? item.innovator_2_4 ?? item.energy_efficiency ?? item.energyEfficiency ?? "",

        innovator3: item.innovator3 ?? item.innovator_3 ?? item.patents ?? item.patents_info ?? "",
        innovator3_1: item.innovator3_1 ?? item.innovator_3_1 ?? item.patents_filed ?? item.patentsFiled ?? "",
        innovator3_2: item.innovator3_2 ?? item.innovator_3_2 ?? item.patents_granted ?? item.patentsGranted ?? "",

        innovator4: item.innovator4 ?? item.innovator_4 ?? item.miscellaneous ?? item.misc ?? "",
        innovator4_1: item.innovator4_1 ?? item.innovator_4_1 ?? item.external_partnerships ?? item.externalPartnerships ?? "",
        innovator4_2: item.innovator4_2 ?? item.innovator_4_2 ?? item.external_recognition ?? item.externalRecognition ?? "",
        innovator4_3: item.innovator4_3 ?? item.innovator_4_3 ?? item.external_presentation ?? item.externalPresentation ?? "",

        innovatortextbox: item.innovatortextbox ?? item.innovation_name ?? item.innovationBox ?? item.innovator_text ?? "",

        // ─── Team Members ───────────────────────────────
        member1: item.member1 ?? item.team_member_1 ?? item.team1 ?? "",
        member2: item.member2 ?? item.team_member_2 ?? item.team2 ?? "",
        member3: item.member3 ?? item.team_member_3 ?? item.team3 ?? "",
        member4: item.member4 ?? item.team_member_4 ?? item.team4 ?? "",
        member5: item.member5 ?? item.team_member_5 ?? item.team5 ?? "",

        // Convenience semantic copies (if your UI expects semantic names)
        // e.g., map model fields into more descriptive keys your inputs might use
        tangible_benefits: item.innovator1 ?? item.tangible_benefits ?? item.innovator_1 ?? "",
        innovation_description: item.innovator1_1 ?? item.innovation_description ?? "",
        quantifiable_impact: item.innovator1_2 ?? item.quantifiable_impact ?? "",
        novelty_uniqueness: item.innovator1_3 ?? item.novelty_uniqueness ?? "",
        scalability: item.innovator1_4 ?? item.scalability ?? "",
        replicability: item.innovator1_5 ?? item.replicability ?? "",
        adaptability: item.innovator1_6 ?? item.adaptability ?? "",

        intangible_impact: item.innovator2 ?? item.intangible_impact ?? "",
        intangible_benefits_hse: item.innovator2_1 ?? item.intangible_benefits_hse ?? "",
        carbon_footprint_reduction: item.innovator2_2 ?? item.carbon_footprint_reduction ?? "",
        quality_compliance: item.innovator2_3 ?? item.quality_compliance ?? "",
        energy_efficiency: item.innovator2_4 ?? item.energy_efficiency ?? "",

        patents: item.innovator3 ?? item.patents ?? "",
        patents_filed: item.innovator3_1 ?? item.patents_filed ?? "",
        patents_granted: item.innovator3_2 ?? item.patents_granted ?? "",

        miscellaneous: item.innovator4 ?? item.miscellaneous ?? "",
        external_partnerships: item.innovator4_1 ?? item.external_partnerships ?? "",
        external_recognition: item.innovator4_2 ?? item.external_recognition ?? "",
        external_presentation: item.innovator4_3 ?? item.external_presentation ?? "",

        // generic / legacy keys
        contactapplicant: item.contactapplicant ?? item.contact_applicant ?? "",

        // meta fields
        created_at: item.created_at ?? null,
        updated_at: item.updated_at ?? null,
      };

      // ─── Attachments 1..4: keep file null, expose url & desc for preview ──
      [1, 2, 3, 4].forEach((n) => {
        const descKey = `attachments${n}_desc`;
        const fileKey = `attachments${n}`;
        const urlKey = `${fileKey}_url`;
        const pathKey = `${fileKey}_path`;
        const altDescKey = `${fileKey}Desc`;

        newFields[fileKey] = {
          description:
            item[descKey] ??
            item[altDescKey] ??
            item[`${fileKey}_description`] ??
            item[`${fileKey}Desc`] ??
            "",
          file: null,
          url:
            item[fileKey] ??
            item[urlKey] ??
            item[pathKey] ??
            item[`${fileKey}_url_path`] ??
            null,
        };
      });

      // ─── Approving authority signature: file null + preview URL if returned ──
      newFields.approvingAuthoritySignature = null;
      newFields.approvingAuthoritySignatureUrl =
        item.approving_authority_file ??
        item.approving_authority_file_url ??
        item.approvingAuthorityFileUrl ??
        item.approving_authority_signature ??
        item.approving_authority_signature_url ??
        null;

      // keep any returned simple meta on state
      if (item.id) newFields.id = item.id;
      if (item.form_id) newFields.form_id = item.form_id;

      // Final merge into state (immutable)
      setFormData((prev) => ({ ...prev, ...newFields }));

      // debug: show what was set (optional)
      console.log("prefill: newFields keys set:", Object.keys(newFields));
    })
    .catch((err) => {
      console.error("prefillFormData error:", err);
    });
}





  // UI State
  const [currentStep, setCurrentStep] = useState(1);
  const [copyApplicantData, setCopyApplicantData] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');




  // Validation helpers
  const validateEmail = (email) => emailRegex.test(email);
  const validatePhone = (phone) => phoneRegex.test(phone);
  const validateNumber = (value) => numberRegex.test(value) || value === '';

  // Clear error on field
  const clearFieldError = useCallback((field) => {
    setFieldErrors((prev) => {
      if (prev[field]) {
        const { [field]: omitted, ...rest } = prev;
        return rest;
      }
      return prev;
    });
  }, []);

  // Validate field on blur
  // const validateField = (name, value) => {
  //   let errorMsg = '';
  //   if (['Organisationname', 'authorityName', 'contact_name'].includes(name)) {
  //     if (!value.trim()) {
  //       errorMsg = `${name} is required.`;
  //     } else if (!/^[A-Za-z\s]*$/.test(value)) {
  //       errorMsg = 'Only letters and spaces are allowed.';
  //     }
  //   } else if (name === 'innovation_name' && !value.trim()) {
  //     errorMsg = 'Name of innovation is required.';
  //   } else if (name === 'mailingAddress' && !value.trim()) {
  //     errorMsg = 'Mailing address is required.';
  //   } else if (name === 'authorityEmail' || name === 'contactEmail') {
  //     if (value && !validateEmail(value)) {
  //       errorMsg = `Please enter a valid ${name === 'authorityEmail' ? 'Authority' : 'Contact'} email.`;
  //     } else if (name === 'authorityEmail' && !value) {
  //       errorMsg = 'Authority email is required.';
  //     }
  //   } else if (name === 'authorityPhone' || name === 'contact_phone') {
  //     if (value && !validatePhone(value)) {
  //       errorMsg = `${name === 'authorityPhone' ? 'Authority' : 'Contact'} phone must be exactly 10 digits.`;
  //     } else if (name === 'authorityPhone' && !value) {
  //       errorMsg = 'Authority phone is required.';
  //     }
  //   } else if (name === 'companyProfile' && value.length > COMPANY_PROFILE_MAX_LENGTH) {
  //     errorMsg = `Company profile must not exceed ${COMPANY_PROFILE_MAX_LENGTH} characters.`;
  //   } else if (name === 'comment' && value.length > COMMENT_MAX_LENGTH) {
  //     errorMsg = `Comment must not exceed ${COMMENT_MAX_LENGTH} characters.`;
  //   } else if (['patents_filed', 'patents_granted'].includes(name) && value && !validateNumber(value)) {
  //     errorMsg = 'Please enter a valid number.';
  //   } else if (Object.keys(TEXTAREA_MAX_LENGTH).includes(name) && value.length > TEXTAREA_MAX_LENGTH[name]) {
  //     errorMsg = `This field must not exceed ${TEXTAREA_MAX_LENGTH[name]} characters.`;
  //   } else if (['member1', 'member2', 'member3', 'member4', 'member5'].includes(name)) {
  //     if (value && !/^[A-Za-z\s]*$/.test(value)) {
  //       errorMsg = 'Only letters and spaces are allowed.';
  //     }
  //   }
  //   return errorMsg;
  // };

  // Handle changes for inputs/textareas/selects
  const handleChange = (name, value, index = null) => {
    if (!name) {
      console.error('handleChange called with undefined name:', { value, index });
      return;
    }

    if ([1, 2, 3, 4].includes(currentStep)) {
      let applicableMaxLength = FIELD_MAX_LENGTH;
      if (name === 'companyProfile') applicableMaxLength = COMPANY_PROFILE_MAX_LENGTH;
      else if (name === 'comment') applicableMaxLength = COMMENT_MAX_LENGTH;
      else if ([
        "tangible_benefits",
        "quantifiable_impact",
        "carbon_footprint_reduction",
        "energy_efficiency",
        "quality_compliance",
        "intangible_impact",
        "innovation_description",
        "novelty_uniqueness",
        "scalability",
        "replicability",
        "adaptability",
        "intangible_benefits_hse",
        "external_partnerships",
        "external_recognition"
      ].includes(name)) {
        applicableMaxLength = 400;
      }

      if (typeof value === 'string') {
        if (name === 'companyProfile') {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 300) {
            alert("Maximum 300 words allowed.");
            return;
          }
        } else if (name === 'comment') {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 200) {
            alert("Maximum 200 words allowed in Comments.");
            return;
          }
        }
        else if (name === 'innovation_description') {
           const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 300) {
            alert("Maximum 300 words allowed ");
            return;
          }
        } else if (name === 'quantifiable_impact') {
           const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 200) {
            alert("Maximum 200 words allowed ");
            return;
          }
        } else if (name === 'novelty_uniqueness') {
           const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 400) {
            alert("Maximum 400 words allowed ");
            return;
          }
        } else if (name === 'scalability') {
           const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 100) {
            alert("Maximum 100 words allowed ");
            return;
          }
        } else if (name === 'replicability') {
           const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 100) {
            alert("Maximum 100 words allowed ");
            return;
          }
        } else if (name === 'adaptability') {
           const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 100) {
            alert("Maximum 100 words allowed ");
            return;
          }
        } else if (name === 'intangible_benefits_hse') {
           const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 300) {
            alert("Maximum 300 words allowed ");
            return;
          }
        } else if (name === 'carbon_footprint_reduction') {
           const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 300) {
            alert("Maximum 300 words allowed ");
            return;
          }
        } else if (name === 'quality_compliance') {
           const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 300) {
            alert("Maximum 300 words allowed .");
            return;
          }
        } else if (name === 'energy_efficiency') {
           const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 300) {
            alert("Maximum 300 words allowed ");
            return;
          }
        } else if (name === 'external_partnerships') {
           const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 100) {
            alert("Maximum 100 words allowed ");
            return;
          }
        } else if (name === 'external_recognition') {
           const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 100) {
            alert("Maximum 100 words allowed ");
            return;
          }
        }

        else if (value.length > applicableMaxLength) {
          alert(`Value cannot exceed ${applicableMaxLength} characters.`);
          return;
        }
      }
    }



    // Validate text fields
    if (['Organisationname', 'authorityName', 'contact_name'].includes(name)) {
      if (value && !/^[A-Za-z\s]*$/.test(value)) {
        return;
      }
    }

    // Phone validation
    if (['authorityPhone', 'contact_phone'].includes(name)) {
      const numericValue = value.replace(/\D/g, '').slice(0, PHONE_MAX_LENGTH);
      setFormData((prev) => ({
        ...prev,
        [name]: numericValue,
      }));
      clearFieldError(name);
      return;
    }

    // Numeric validation for patent fields


    // Team members limit check
    if (['member1', 'member2', 'member3', 'member4', 'member5'].includes(name)) {
      const filledMembers = ['member1', 'member2', 'member3', 'member4', 'member5'].filter(
        (m) => formData[m] || (m === name && value)
      ).length;
      if (filledMembers > 5) {
        setFieldErrors((prev) => ({
          ...prev,
          [name]: 'Maximum limit of 5 team members reached.',
        }));
        return;
      }
      if (value && !/^[A-Za-z\s]*$/.test(value)) {
        return;
      }
    }

    // Default handling
    setFormData((prev) => ({
      ...prev,
      [name]: typeof value === 'boolean' ? value : value || '',
    }));
    clearFieldError(name);

    // Clear step-specific errors
    if (name === 'Organisationname' && value && currentStep === 1) setError('');
    if (name === 'innovation_name' && value && currentStep === 1) setError('');
    if (name === 'mailingAddress' && value?.trim() && currentStep === 1) setError('');
    if (name === 'authorityName' && value && currentStep === 2) setError('');
    if (name === 'authorityTitle' && value && currentStep === 2) setError('');
    if (name === 'authorityEmail' && value && currentStep === 2) setError('');
    if (name === 'authorityPhone' && value && currentStep === 2) setError('');
  };

  // Handle blur for validation
  // const handleBlur = (name, value) => {
  //   const errorMsg = validateField(name, value);
  //   if (errorMsg) {
  //     setFieldErrors((prev) => ({ ...prev, [name]: errorMsg }));
  //     alert(errorMsg);
  //   } else {
  //     clearFieldError(name);
  //   }
  // };

  // Handle checkbox for copying applicant data

  
 const handleCopyApplicantToggle = (e) => {
    const checked = e.target.checked;
    // setCopyApplicantData(checked);

    const model = {
      contact_name: "",
      contact_phone: "",
      contact_email: "",
    };

    if (checked) {
      const userInfo = JSON.parse(sessionStorage.getItem('user_info'));
      if(userInfo){
        model.contact_name = userInfo.applicant_name;
        model.contact_phone = userInfo.applicant_phone;
        model.contact_email = userInfo.email;
      }
    };

    setFormData((prev) => ({...prev, ...model}))

    clearFieldError("contact_name");
    clearFieldError("contact_phone");
    clearFieldError("contact_email");
  };

  // Handle attachment changes
  const handleAttachmentChange = (key, field, value, event = null) => {
    if (field === 'file' && value) {
      const file = value;
      const maxSizeInBytes = 5 * 1024 * 1024;
      const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];

      if (!allowedTypes.includes(file.type)) {
        alert('Only JPG, PNG, and PDF files are allowed for attachments.');
        if (event) event.target.value = null;
        return;
      }
      if (file.size > maxSizeInBytes) {
        alert('File size must not exceed 5 MB for attachments.');
        if (event) event.target.value = null;
        return;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
    clearFieldError(key);
  };

  // Handle approving authority signature upload
  const handleApprovingAuthorityChange = (files) => {
    const file = files[0];
    if (file) {
      const maxSizeInBytes = 5 * 1024 * 1024;
      const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];

      if (!allowedTypes.includes(file.type)) {
        alert('Only JPG, PNG, and PDF files are allowed for the signature.');
        return;
      }
      if (file.size > maxSizeInBytes) {
        alert('File size must not exceed 5 MB for the signature.');
        return;
      }
      setFormData((prev) => ({
        ...prev,
        approvingAuthoritySignature: file,
      }));
      clearFieldError('approvingAuthoritySignature');
    }
  };

  const handlePrint = () => {
  const submissionDate = new Date('2025-08-05T15:44:00+05:30').toLocaleString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    timeZone: 'Asia/Kolkata',
  });

  const printContent = `
    <div style="font-family: Arial, sans-serif; padding: 20px;">
      <h1 style="text-align: center; color: #1e40af;">${awardTitle}</h1>

      <h2>Organization & Contact Details</h2>
      <p><strong>Organisation Name:</strong> ${formData.Organisationname || ''}</p>
      <p><strong>Name of the Innovation:</strong> ${formData.innovation_name || ''}</p>
      <p><strong>Postal Address:</strong> ${formData.mailingAddress || ''}</p>

      <h2>Approving Authority Details</h2>
      <p><strong>Approving Authority Name:</strong> ${formData.authorityName || ''}</p>
      <p><strong>Approving Authority Designation:</strong> ${formData.authorityTitle || ''}</p>
      <p><strong>Approving Authority Landline:</strong> ${formData.authorityLandline || ""}</p>
      <p><strong>Approving Authority Phone:</strong> ${formData.authorityPhone || ''}</p>
      <p><strong>Approving Authority Email:</strong> ${formData.authorityEmail || ''}</p>

      <h2>Nodal Official Contact Details:</h2>
      <p><strong>Contact Name:</strong> ${formData.contact_name || ''}</p>
      <p><strong>Contact Phone:</strong> ${formData.contact_phone || ''}</p>
      <p><strong>Contact Email:</strong> ${formData.contact_email || ''}</p>
      <p><strong>Brief write up on company’s profile:</strong> ${formData.companyProfile || ''}</p>

      <h2>Quantitative Information - Part 1</h2>
      <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px;">S. No.</th>
            <th style="border: 1px solid #000; padding: 8px;">Particulars</th>
            <th style="border: 1px solid #000; padding: 8px;">Response</th>
          </tr>
        </thead>
        <tbody>
          ${part1.map(([num, label, key]) => `
            <tr>
              <td style="border: 1px solid #000; padding: 8px;">${num}</td>
              <td style="border: 1px solid #000; padding: 8px;">${label}</td>
              <td style="border: 1px solid #000; padding: 8px;">${formData[key] || ''}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>

      <h2>Quantitative Information - Part 2</h2>
      <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px;">S. No.</th>
            <th style="border: 1px solid #000; padding: 8px;">Particulars</th>
            <th style="border: 1px solid #000; padding: 8px;">Response</th>
          </tr>
        </thead>
        <tbody>
          ${part2.map(([num, label, key]) => `
            <tr>
              <td style="border: 1px solid #000; padding: 8px;">${num}</td>
              <td style="border: 1px solid #000; padding: 8px;">${label}</td>
              <td style="border: 1px solid #000; padding: 8px;">${formData[key] || ''}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>

      <h2>List of Team Members (Max. 5 entries per company)</h2>
      <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px;">S. No.</th>
            <th style="border: 1px solid #000; padding: 8px;">Name</th>
          </tr>
        </thead>
        <tbody>
          ${members.map(([num, key]) => `
            <tr>
              <td style="border: 1px solid #000; padding: 8px;">${num}</td>
              <td style="border: 1px solid #000; padding: 8px;">${formData[key] || ''}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>

      <h2>Attachments</h2>
      <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px;width:10px">S. No.</th>
            <th style="border: 1px solid #000; padding: 8px;">Description</th>
            <th style="border: 1px solid #000; padding: 8px;">File</th>
          </tr>
        </thead>
        <tbody>
          ${[1, 2, 3, 4].map((n) => {
            const attachment = formData[`attachments${n}`];
            return `
              <tr>
                <td style="border: 1px solid #000; padding: 8px;">${n}</td>
                <td style="border: 1px solid #000; padding: 8px;">${attachment.description || ''}</td>
                <td style="border: 1px solid #000; padding: 8px;">${attachment.file?.name || ''}</td>
              </tr>
            `;
          }).join('')}
        </tbody>
      </table>

      <h2>Declaration</h2>
      <p>I declare that the information submitted is true and complete.</p>
      <br/>
      <p><strong>Approving Authority Name:</strong> ${formData.authorityName || ''}</p>
      <p><strong>Approving Authority Designation:</strong> ${formData.authorityTitle || ''}</p>
      <p><strong>Signed on:</strong> ${formData.signatureDate || new Date().toLocaleDateString()}</p>
      <p><strong>Approving Authority Signature:</strong></p>
    </div>
  `;

  const printWindow = window.open('', '_blank', 'height=600,width=800');
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8">
        <title>${awardTitle || 'Form Submission'}</title>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
  `);
  printWindow.document.close();
  printWindow.print();
};


  // Navigation handlers
  const nextStep = () => {
    const errors = {};
    if (currentStep === 1) {
      if (!formData.Organisationname) {
        errors.Organisationname = 'Organisation name is required.';
      }
      if (!formData.mailingAddress?.trim()) {
        errors.mailingAddress = 'Mailing address is required.';
      }
      if (!formData.innovation_name?.trim()) {
        errors.innovation_name = 'Name of innovation is required.';
      }
    }
    if (currentStep === 2) {
      if (!formData.authorityName) {
        errors.authorityName = 'Authority name is required.';
      }
      if (!formData.authorityTitle) {
        errors.authorityTitle = 'Authority designation is required.';
      }
      if (!formData.authorityEmail || !validateEmail(formData.authorityEmail)) {
        errors.authorityEmail = 'Please enter a valid Authority email.';
      }
      // if (!formData.authorityPhone || !validatePhone(formData.authorityPhone)) {
      //   errors.authorityPhone = 'Authority phone must be exactly 10 digits.';
      // }
      if (!formData.authorityLandline) {
                alert('Authority Landline is required.');
                return;
      }
      if (!formData.contact_name) {
        errors.contact_name = 'Contact name is required.';
      }
      if (formData.contact_email && !validateEmail(formData.contact_email)) {
        errors.contact_email = 'Please enter a valid Contact email.';
      }
      if (formData.contact_phone && !validatePhone(formData.contact_phone)) {
        errors.contact_phone = 'Contact phone must be exactly 10 digits.';
      }
      if (!formData.companyProfile) {
        errors.contact_name = 'Company Profile is required.';
      }
    }
    if (currentStep === 3 && checkEmptyFieldsStep(3)) {
      if (!window.confirm("Data not entered,If you wish to continue?")) return;
    }
    if (currentStep === 4 && checkEmptyFieldsStep(4)) {
      if (!window.confirm("Data not entered,If you wish to continue?")) return;
    }

    setError('');
    if (currentStep < 5) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep((prev) => prev - 1);
  };

  // Save draft handler
  const handleSaveDraft = () => {
    localStorage.setItem("registration-innovatorDraft", JSON.stringify({ formData }));
    handleSubmit(null);
    alert("Draft Saved!");
  };

  //Final Submit button

  useEffect(() => {
    if (userInfo) {
      validateFormCount().catch((err) => {
        alert(`${err.message}`);
        setDisableSave(true);
      });
    }
  }, [userInfo]);

  const validateFormCount = async () => {
    const url = `/registration-innovator/?organisation_name=${userInfo.organisation_name}&form_mode=submit`;
    const res = await apiClient.get(url);

    if (res?.data?.length === 5) {
      // disable buttons
      setDisableSave(true);
      throw new Error(
        "You have reached the maximum limit of 5 forms for this organisation."
      );
    }
  };

  
async function handleSubmit(event, clickType = "draft") {
    if (event) {
      event?.preventDefault();
    }
    try {
      await validateFormCount();

      // 1) Make a local copy of formData so we don't rely on async state updates
      let payload = { ...formData };

      // 2) Merge user_info synchronously (don't call setFormData here)
      try {
        const raw = localStorage.getItem("user_info");
        if (raw) {
          const u = JSON.parse(raw);
          payload.userid = u.id || "";
          payload.firstname = u.first_name || "";
          payload.lastname = u.last_name || "";
          payload.company_name = u.organisation_name ?? payload.company_name;
          payload.Organisationname =
            u.organisation_name ?? payload.Organisationname;
        }
      } catch (err) {
        console.warn("Failed to load user_info:", err);
      }

  // Basic validations



  const fd = new FormData();

  const fieldMap = {
    organisation_name: formData.Organisationname,
      firstname: formData.firstname,
      lastname: formData.lastname,  
    category: formData.category,
    company_name: formData.companyName,
    mailing_address: formData.mailingAddress,
    authority_name: formData.authorityName,
    authority_title: formData.authorityTitle,
    authority_phone: formData.authorityPhone,
    authorityLandline: formData.authorityLandline,
    authority_email: formData.authorityEmail,
    contact_name: formData.contact_name,
    contact_phone: formData.contact_phone,
    contact_email: formData.contact_email,
    company_profile: formData.companyProfile,
    declaration: formData.declaration ? 'true' : 'false',
    comment: formData.comment,

    innovatortextbox: formData.innovation_name,
    innovator1: formData.tangible_benefits,
    innovator1_1: formData.innovation_description,
    innovator1_2: formData.quantifiable_impact,
    innovator1_3: formData.novelty_uniqueness,
    innovator1_4: formData.scalability,
    innovator1_5: formData.replicability,
    innovator1_6: formData.adaptability,
    innovator2: formData.intangible_impact,
    innovator2_1: formData.intangible_benefits_hse,
    innovator2_2: formData.carbon_footprint_reduction,
    innovator2_3: formData.quality_compliance,
    innovator2_4: formData.energy_efficiency,
    innovator3: formData.patents,
    innovator3_1: formData.patents_filed,
    innovator3_2: formData.patents_granted,
    innovator4: formData.miscellaneous,
    innovator4_1: formData.external_partnerships,
    innovator4_2: formData.external_recognition,
    innovator4_3: formData.external_presentation,

    member1: formData.member1,
    member2: formData.member2,
    member3: formData.member3,
    member4: formData.member4,
    member5: formData.member5,
  };

  Object.entries(fieldMap).forEach(([key, value]) => {
    fd.append(key, value || '');
  });

  fd.append("form_id", formId);
      fd.append("form_mode", clickType);
      // Add Table Pk Id;
      if (PkId > 0) fd.append("id", PkId);

      if (payload.approvingAuthoritySignature instanceof File) {
        fd.append(
          "approving_authority_file",
          payload.approvingAuthoritySignature
        );
      }

  [1, 2, 3, 4].forEach((n) => {
    const desc = formData[`attachments${n}`]?.description || '';
    const file = formData[`attachments${n}`]?.file;
    fd.append(`attachments${n}_desc`, desc);
    if (file) fd.append(`attachments${n}`, file);
  });


  try {
          const response = await apiClient.post("/registration-innovator/", fd, {
            headers: { "Content-Type": "multipart/form-data" },
          });
  
          // When User save the Data It will Prefill the form data and fill pkId
          prefillFormData();
        } catch (err) {
          console.error("registration-innovator submission error:", err);
          const serverMsg =
            err?.response?.data ?? err?.message ?? JSON.stringify(err);
          alert("Submission failed: " + JSON.stringify(serverMsg));
        }
      } catch (err) {
        console.error(`Error submitting form :: ${err}`);
      }
    };
  // Quantitative fields definition
  const part1 = [
    ['1', 'Tangible benefits of the innovation', 'tangible_benefits'],
    [
      '1.1',
      'Brief description of the innovation along with details of Technology used, Gestation period, financial implication, Innovative practices and the Development lifecycle (inception to implementation). (Max. 300 words)',
      'innovation_description',
    ],
    [
      '1.2',
      'Quantifiable impact of innovation: a. Cost savings b. Operational efficiency gains/improvement in productivity (Please provide data with units, if applicable). (Max. 200 words)',
      'quantifiable_impact',
    ],
    [
      '1.3',
      'Novelty and uniqueness: a. Uniqueness of the innovation. b. Technological challenges that have been overcome. c. Environmental gain accrued. d. New technologies used (especially Digital Technologies). (Max. 400 words).',
      'novelty_uniqueness',
    ],
    ['1.4', 'Scalability: Can the innovation be scaled across the oil & gas/energy sector (India/global)? (Max. 100 words).', 'scalability'],
    ['1.5', 'Replicability: Can the innovation be implemented by other companies in the oil & gas/energy sector under similar conditions? (Max. 100 words).', 'replicability'],
    ['1.6', 'Adaptability: Potential for further improvement or adaptation. Could this innovation evolve further? (Max. 100 words).', 'adaptability'],
    ['2', 'Intangible Impact', 'intangible_impact'],
    ['2.1', 'Intangible benefits: Describe impact on the following: (Max. 300 words)a. Health, Safety & Environment (HSE)', 'intangible_benefits_hse'],
    ['2.2', 'b. Carbon footprint reduction', 'carbon_footprint_reduction'],
    ['2.3', 'c. Quality or compliance improvements', 'quality_compliance'],
    ['2.4', 'd. Energy efficiency', 'energy_efficiency'],
  ];

  const part2 = [
    ['3', 'Patents', 'patents'],
    ['3.1', 'Number of patents filed for the innovation', 'patents_filed'],
    ['3.2', 'Number of domestic/international patents granted', 'patents_granted'],
    ['4', 'Miscellaneous', 'miscellaneous'],
    ['4.1', 'Team composition and cross-functional collaboration (Max. 100 words). ', 'external_partnerships'],
    ['4.2', 'External partnerships with academia/startups/R&D (Max. 100 words). ', 'external_recognition'],
    ['4.3', 'Recognition or awards received from external bodies (other than the company itself) ', 'external_presentation'],
  ];

  const members = [
    ['1.        Team Lead  ', 'member1'],
    ['2.', 'member2'],
    ['3.', 'member3'],
    ['4.', 'member4'],
    ['5.', 'member5'],
  ];
  const checkEmptyFieldsStep = (step) => {
    // Choose the data array slice depending on step
    const stepData = step === 3 ? part1 : part2;

    // Iterate and check if any related formData[key] is empty
    for (let [num, label, key] of stepData) {
      const value = formData[key];
      // For textareas or inputs, treat empty string or undefined as empty
      if (!value || (Array.isArray(value) && value.some(v => !v))) {
        // skip keys you want to ignore here if any, e.g. optional fields
        if (['tangible_benefits', 'intangible_impact', 'patents', 'miscellaneous'].includes(key))
          continue;
        return true; // found empty
      }
    }
    return false; // all filled
  };

     const viewFile =  async (serverPath) => {
    // "https://award-backend.fipi.org.in/media/
    const extractPath = serverPath.split('/').filter(
  (val) =>
    val !== "" && // remove empty strings
    val !== "http:" &&
    val !== "https:" &&
    val !== "media" &&
    !val.startsWith("award") &&
    !val.startsWith("localhost")
).join('/');
    
    downloadFile(extractPath)
  }



  const renderStepContent = () => {
    const progress = ((currentStep - 1) / 4) * 100;
    return (
      <div className="form-step" role="region" aria-label={`Step ${currentStep} of 5`}>
        <div className="progress-bar" role="progressbar" aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100">
          <div className="progress" style={{ width: `${progress}%` }}></div>
        </div>

        {currentStep === 1 && (
          <div>
            <h3 className="step-title">Step 1: Organization Details</h3>
            <div className="form-group">
              <label htmlFor="Organisationname">
                Organisation Name: 
                {/* <span className="text-red" aria-hidden="true">*</span> */}
              </label>
              <input
                id="Organisationname"
                type="text"
                name="Organisationname"
                value={formData.Organisationname}
                disabled={true} 
                // onChange={(e) => handleChange('Organisationname', e.target.value)}
                // onBlur={(e) => handleBlur('Organisationname', e.target.value)}
                className={`form-input ${!formData.Organisationname && currentStep === 1 ? 'has-error' : ''}`}
                placeholder="Enter organisation name"
                maxLength={FIELD_MAX_LENGTH}
                aria-required="true"
                aria-describedby={fieldErrors.Organisationname ? 'Organisationname-error' : undefined}
              />
              {!formData.Organisationname && currentStep === 1 && <span className="error-tooltip">Organisation name is required</span>}
            </div>


            <div className="form-group">
              <label htmlFor="innovation_name">
                Name of the Innovation: <span className="text-red" aria-hidden="true">*</span>
              </label>
              <input
                id="innovation_name"
                type="text"
                name="innovation_name"
                value={formData.innovation_name}
                onChange={(e) => handleChange('innovation_name', e.target.value)}
               
                className={`form-input ${!formData.innovation_name && currentStep === 1 ? 'has-error' : ''}`}
                placeholder="Enter name of innovation"
                maxLength={INNOVATION_NAME_MAX_LENGTH}
                aria-required="true"
                aria-describedby={fieldErrors.innovation_name ? 'innovation_name-error' : undefined}
              />
              {!formData.innovation_name && currentStep === 1 && <span className="error-tooltip">Innovation name is required</span>}
            </div>
            <div className="form-group">
              <label htmlFor="mailingAddress">
                Postal Address: <span className="text-red" aria-hidden="true">*</span>
              </label>
              <textarea
                id="mailingAddress"
                name="mailingAddress"
                value={formData.mailingAddress}
                onChange={(e) => handleChange('mailingAddress', e.target.value)}
                // onBlur={(e) => handleBlur('mailingAddress', e.target.value)}
                className={`form-textarea ${!formData.mailingAddress && currentStep === 1 ? 'has-error' : ''}`}
                rows={3}
                placeholder="Enter Postal address"
                aria-required="true"
                aria-describedby={fieldErrors.mailingAddress ? 'mailingAddress-error' : undefined}
              />
              {!formData.mailingAddress && currentStep === 1 && <span className="error-tooltip">Postal address is required</span>}
            </div>
          </div>
        )}
        {currentStep === 2 && (
          <div>
            <h3 className="step-title">Step 2: Approving Authority & Contact Details</h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="step-section">
                <h4>Approving Authority</h4>
                <p className="note">Approving authority should be concerned  Director /Board level executive. </p>
                <div className="form-group">
                  <label htmlFor="authorityName">
                    Name: <span className="text-red" aria-hidden="true">*</span>
                  </label>
                  <input
                    id="authorityName"
                    type="text"
                    name="authorityName"
                    value={formData.authorityName}
                    onChange={(e) => handleChange('authorityName', e.target.value)}
                    // onBlur={(e) => handleBlur('authorityName', e.target.value)}
                    className={`form-input ${!formData.authorityName && currentStep === 2 ? 'has-error' : ''}`}
                    placeholder="Name"
                    maxLength={FIELD_MAX_LENGTH}
                    aria-required="true"
                    aria-describedby={fieldErrors.authorityName ? 'authorityName-error' : undefined}
                  />
                  {!formData.authorityName && currentStep === 2 && <span className="error-tooltip">Authority name is required</span>}
                </div>
                <div className="form-group">
                  <label htmlFor="authorityTitle">
                    Designation: <span className="text-red" aria-hidden="true">*</span>
                  </label>
                  <input
                    id="authorityTitle"
                    type="text"
                    name="authorityTitle"
                    value={formData.authorityTitle}
                    onChange={(e) => handleChange('authorityTitle', e.target.value)}
                    // onBlur={(e) => handleBlur('authorityTitle', e.target.value)}
                    className={`form-input ${!formData.authorityTitle && currentStep === 2 ? 'has-error' : ''}`}
                    placeholder="Designation"
                    maxLength={FIELD_MAX_LENGTH}
                    aria-required="true"
                    aria-describedby={fieldErrors.authorityTitle ? 'authorityTitle-error' : undefined}
                  />
                  {!formData.authorityTitle && currentStep === 2 && <span className="error-tooltip">Authority Designation is required</span>}
                </div>
                

                                <div className="form-group">
                  <label htmlFor="authorityPhone">
                    Landline:{" "}
                    <span className="text-red" aria-hidden="true">*</span>
                  </label>
                  <input
                    id="authorityLandline"
                    type="number"
                    name="authorityLandline"
                    value={formData.authorityLandline}
                    onChange={(e) =>
                      handleChange("authorityLandline", e.target.value)
                    }
                    // onBlur={(e) => handleBlur('authorityLandline', e.target.value)}
                    className={`form-input ${
                      !formData.authorityLandline && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    placeholder="Landline number"
                    aria-required="true"
                    aria-describedby={
                      fieldErrors.authorityLandline
                        ? "authorityLandline-error"
                        : undefined
                    }
                  />
                  {!formData.authorityLandline && currentStep === 2 && (
                    <span className="error-tooltip">
                      Authority Landline Number is required
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="authorityPhone">
                    Mobile:{" "}
                    {/* <span className="text-red" aria-hidden="true"></span> */}
                  </label>
                  <input
                    id="authorityPhone"
                    type="tel"
                    name="authorityPhone"
                    value={formData.authorityPhone}
                    onChange={(e) =>
                      handleChange("authorityPhone", e.target.value)
                    }
                    // onBlur={(e) => handleBlur('authorityPhone', e.target.value)}
                    className={`form-input`}
                    placeholder="Phone number"
                    maxLength={PHONE_MAX_LENGTH}
                    aria-required="true"
                    // aria-describedby={fieldErrors.authorityPhone ? 'authorityPhone-error' : undefined}
                  />
                </div>


                <div className="form-group">
                  <label htmlFor="authorityEmail">
                    Email Address: <span className="text-red" aria-hidden="true">*</span>
                  </label>
                  <input
                    id="authorityEmail"
                    type="email"
                    name="authorityEmail"
                    value={formData.authorityEmail}
                    onChange={(e) => handleChange('authorityEmail', e.target.value)}
                    // onBlur={(e) => handleBlur('authorityEmail', e.target.value)}
                    className={`form-input ${!formData.authorityEmail && currentStep === 2 ? 'has-error' : ''}`}
                    placeholder="E-mail address"
                    aria-required="true"
                    aria-describedby={fieldErrors.authorityEmail ? 'authorityEmail-error' : undefined}
                  />
                  {!formData.authorityEmail && currentStep === 2 && <span className="error-tooltip">Authority Email is required</span>}
                </div>
              </div>
              <div className="step-section">
                <h4>Contacts (Nodal Officials) <span className="text-red" aria-hidden="true">*</span></h4>
                <div className="form-group">
                  <label>
                    <input
                      type="checkbox"
                      name="copyApplicantData"
                      // checked={copyApplicantData}
                      onChange={handleCopyApplicantToggle}
                      className="form-checkbox"
                    />{" "}
                    Same as applicant
                  </label>
                </div>

                <div className="form-group">
                  <label htmlFor="contact_name">
                    Name <span aria-hidden="true" className="text-red">*</span>
                  </label>
                  <input
                    id="contact_name"
                    name="contact_name"
                    type="text"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.contact_name}
                    onChange={(e) => handleChange("contact_name", e.target.value)}
                    placeholder="Contact name"
                    disabled={copyApplicantData}
                    className={`form-input ${!formData.contact_name && currentStep === 2 ? "has-error" : ""}`}
                    aria-describedby="contact_name-error"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact_phone">
                    Phone:<span aria-hidden="true" className="text-red">*</span>
                  </label>
                  <input
                    id="contact_phone"
                    name="contact_phone"
                    type="tel"
                    maxLength={PHONE_MAX_LENGTH}
                    value={formData.contact_phone}
                    onChange={(e) => handleChange("contact_phone", e.target.value)}
                    aria-describedby="contact_phone-error"
                    disabled={copyApplicantData}
                    placeholder="10-digit phone number"
                    className={`form-input ${!formData.contact_phone && currentStep === 2 ? "has-error" : ""}`}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact_email">Email</label>
                  <input
                    id="contact_email"
                    name="contact_email"
                    type="email"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.contact_email}
                    onChange={(e) => handleChange("contact_email", e.target.value)}
                    placeholder="Contact email"
                    disabled={copyApplicantData}
                    className={`form-input ${fieldErrors.contact_email ? "has-error" : ""}`}
                    aria-describedby="contact_email-error"
                  />
                </div>


              </div>
            </div>
            <div className="form-group">
              <label htmlFor="companyProfile">Brief write up on company’s profile. </label>
              <p className="note">(within 300 words)</p>
              <textarea
                id="companyProfile"
                name="companyProfile"
                value={formData.companyProfile}
                onChange={(e) => handleChange('companyProfile', e.target.value)}
                // onBlur={(e) => handleBlur('companyProfile', e.target.value)}
                className={`form-input ${!formData.companyProfile && currentStep === 2 ? 'has-error' : ''}`}
                rows={6}
                // maxLength={COMPANY_PROFILE_MAX_LENGTH}
                aria-describedby={fieldErrors.companyProfile ? 'companyProfile-error' : undefined}
              />
              {!formData.companyProfile && currentStep === 2 && <span className="error-tooltip">company profile is required</span>}
            </div>
          </div>
        )}
        {currentStep === 3 && (
          <div>
            <h3 className="step-title">Step 3: Quantitative Information Part 1</h3>
            <table className="quant-table">
              <thead>
                <tr>
                  <th scope="col">S. No.</th>
                  <th scope="col">Particulars</th>
                  <th scope="col">Response</th>
                </tr>
              </thead>
              <tbody>
                {part1.map(([num, label, key]) => (
                  <tr key={key || label}>
                    <td>{num}</td>
                    <td>{label}</td>
                    <td>
                      {['tangible_benefits', 'intangible_impact'].includes(key) ? (
                        <span></span>
                      ) : (
                        <textarea
                          value={formData[key] || ''}
                          onChange={(e) => handleChange(key, e.target.value)}
                          // onBlur={(e) => handleBlur(key, e.target.value)}
                          className={`form-textarea ${fieldErrors[key] ? 'has-error' : ''}`}
                          rows={6}
                          // maxLength={TEXTAREA_MAX_LENGTH[key] || 300}
                          aria-label={`${label} input`}
                          aria-describedby={fieldErrors[key] ? `${key}-error` : undefined}
                        />
                      )}
                      {fieldErrors[key] && (
                        <span id={`${key}-error`} className="error-tooltip" role="alert">
                          {fieldErrors[key]}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {currentStep === 4 && (
          <div>
            <h3 className="step-title">Step 4: Quantitative Information Part 2</h3>
            <table className="quant-table">
              <thead>
                <tr>
                  <th scope="col">S. No.</th>
                  <th scope="col">Particulars</th>
                  <th scope="col">Response</th>
                </tr>
              </thead>
              <tbody>
                {part2.map(([num, label, key]) => (
                  <tr key={key || label}>
                    <td>{num}</td>
                    <td>{label}</td>
                    <td>
                      {['patents', 'miscellaneous'].includes(key) ? (
                        <span></span>
                      ) : (
                        ['patents_filed', 'patents_granted'].includes(key) ? (
                          <input
                            type="number"
                            value={formData[key] || ''}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (!val.startsWith('-') && !val.toLowerCase().includes('e')) {
                                handleChange(key, val);
                              }
                            }}
                            // onBlur={(e) => handleBlur(key, e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                e.preventDefault();
                              }
                            }}
                            className={`form-input no-spinner ${fieldErrors[key] ? 'has-error' : ''}`}
                            placeholder="Enter value"
                            min="0"
                            aria-label={`${label} input`}
                            aria-describedby={fieldErrors[key] ? `${key}-error` : undefined}
                          />
                        ) : (
                          <input
                            type="text"
                            value={formData[key] || ''}
                            onChange={(e) => handleChange(key, e.target.value)}
                            // onBlur={(e) => handleBlur(key, e.target.value)}
                            className={`form-input ${fieldErrors[key] ? 'has-error' : ''}`}
                            placeholder="Enter value"
                            // maxLength={TEXTAREA_MAX_LENGTHS[key] || undefined}
                            aria-label={`${label} input`}
                            aria-describedby={fieldErrors[key] ? `${key}-error` : undefined}
                          />
                        )
                      )}
                      {fieldErrors[key] && (
                        <span id={`${key}-error`} className="error-tooltip" role="alert">
                          {fieldErrors[key]}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <table className="quant-table">
              <caption className="table-header">List of Team Members (Max. 5 entries per company)</caption>
              <p className="note">Note: Only up to 5 team members can be added.</p>
              {['member1', 'member2', 'member3', 'member4', 'member5']
                .filter((m) => formData[m])
                .length >= 5 && (
                  <p className="error-tooltip" role="alert">
                    Maximum limit of 5 team members reached.
                  </p>
                )}
              <thead>
                <tr>
                  <th scope="col">S. No.</th>
                  <th scope="col">Name</th>
                </tr>
              </thead>
              <tbody>
                {members.map(([num, key]) => (
                  <tr key={key}>
                    <td>{num}</td>
                    <td>
                      <input
                        type="text"
                        value={formData[key] || ''}
                        onChange={(e) => handleChange(key, e.target.value)}
                        // onBlur={(e) => handleBlur(key, e.target.value)}
                        className={`form-input ${fieldErrors[key] ? 'has-error' : ''}`}
                        disabled={
                          ['member1', 'member2', 'member3', 'member4', 'member5'].filter((m) => formData[m]).length >=
                          5 && !formData[key]
                        }
                        aria-label={`Team member ${num} name`}
                        aria-describedby={fieldErrors[key] ? `${key}-error` : undefined}
                      />
                      {fieldErrors[key] && (
                        <span id={`${key}-error`} className="error-tooltip" role="alert">
                          {fieldErrors[key]}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="form-group">
              <label htmlFor="comment">Comments</label>
              <textarea
                id="comment"
                name="comment"
                value={formData.comment}
                onChange={(e) => handleChange('comment', e.target.value)}
                // onBlur={(e) => handleBlur('comment', e.target.value)}
                className={`form-textarea ${fieldErrors.comment ? 'has-error' : ''}`}
                // maxLength={COMMENT_MAX_LENGTH}
                placeholder="Comments in (200 characters) against input parameter, if any"
                aria-describedby={fieldErrors.comment ? 'comment-error' : undefined}
              />
              {fieldErrors.comment && (
                <span id="comment-error" className="error-tooltip" role="alert">
                  {fieldErrors.comment}
                </span>
              )}
            </div>
          </div>
        )}

        {currentStep === 5 && (
          <div className="form-step">
            <h3 className="step-title">Step 5: Attachments & Declaration</h3>
            <div className="form-group">
              <label>List of Attachments (Optional):</label>
              <table className="quant-table">
                <thead>
                  <tr>
                    <th scope="col">S. No.</th>
                    <th scope="col">Description</th>
                    <th scope="col">Upload (only jpg, png, pdf, max 5 MB each)</th>
                  </tr>
                </thead>
                {/* <tbody>
                  {[1, 2, 3, 4].map((num) => {
                    const key = `attachments${num}`;
                    const attachment = formData[key];
                    return (
                      <tr key={key}>
                        <td>{num}</td>
                        <td>
                          <input
                            type="text"
                            name={`${key}.description`}
                            value={attachment.description}
                            onChange={(e) => handleAttachmentChange(key, 'description', e.target.value)}
                            onBlur={(e) => handleBlur(`${key}.description`, e.target.value)}
                            placeholder="Enter description"
                            className={`form-input ${fieldErrors[`${key}.description`] ? 'has-error' : ''}`}
                            maxLength={FIELD_MAX_LENGTH}
                            aria-label={`Attachment ${num} description`}
                            aria-describedby={fieldErrors[`${key}.description`] ? `${key}-description-error` : undefined}
                          />
                          {fieldErrors[`${key}.description`] && (
                            <span id={`${key}-description-error`} className="error-tooltip" role="alert">
                              {fieldErrors[`${key}.description`]}
                            </span>
                          )}
                        </td>
                        <td>
                          <input
                            type="file"
                            accept=".jpg,.png,.pdf"
                            onChange={(e) => handleAttachmentChange(key, 'file', e.target.files[0], e)}
                            className="form-input mt-4"
                            aria-label={`Upload attachment ${num}`}
                          />
                          {attachment.file && (
                            <p className="file-name">Selected file: {attachment.file.name}</p>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody> */}
                <tbody>
                  {[1, 2, 3, 4].map((num) => {
                    const key = `attachments${num}`;
                    const attachment = formData[key] || { description: "", file: null };
                    return (
                      <tr key={key}>
                        <td>{num}</td>
                        <td>
                          <input type="text" name={`${key}.description`} value={attachment.description} onChange={(e) => handleAttachmentChange(key, "description", e.target.value)} placeholder="Enter description" maxLength={FIELD_MAX_LENGTH} className="form-input" />
                        </td>
                        <td>
                          <input type="file" accept=".jpg,.png,.pdf" onChange={(e) => handleAttachmentChange(key, "file", e.target.files[0], e)} className="form-input mt-4" />
                          {attachment.file && <p className="file-name">Selected file: {attachment.file.name}</p>}
                          {attachment.url && !attachment.file && (
  <p className="file-name">
    Uploaded file:{" "}
    <button
      type="button"
      onClick={() => viewFile(attachment.url)}
      style={{ background: "none", border: "none", padding: 0, color: "#06c", cursor: "pointer", textDecoration: "underline" }}
    >
      View
    </button>
  </p>
)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="form-group">
              <label>
                Print the completed application form and upload it with the signature of the approving authority. Without signature of the approving authority, application will not be considered valid.
                <span className="text-red" aria-hidden="true">*</span>
              </label>
              <div className="form-navigation">
                <button type="button" onClick={handlePrint} className="btn btn-outline">
                  Print Preview
                </button>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="approvingAuthoritySignature">
                Upload Document with Approving Authority Signature
                (Director/Board Level)
                <span aria-hidden="true" className="text-red">
                  *
                </span>
                :
              </label>
              <input
                type="file"
                id="approvingAuthoritySignature"
                accept=".jpg,.png,.pdf"
                onChange={(e) => {
                  const files = e.target.files;
                  if (files.length > 0) {
                    const confirmed = window.confirm(
                      "Are you sure the form is approved and signed by approving authority?"
                    );
                    if (!confirmed) {
                      // If user clicks "Cancel", clear the input
                      e.target.value = "";
                      return;
                    }
                    handleApprovingAuthorityChange(files);
                  }
                }}
                className={`form-input mt-4 ${
                  fieldErrors.approvingAuthoritySignature ? "has-error" : ""
                }`}
                aria-describedby="approvingAuthoritySignature-error"
                required
              />
              {formData.approvingAuthoritySignature && (
                <p className="file-name">
                  Selected file: {formData.approvingAuthoritySignature.name}
                </p>
              )}
               {formData.approvingAuthoritySignatureUrl && !formData.approvingAuthoritySignature && (
    <p className="file-name">
      Uploaded file:{" "}
      <button
        type="button"
        onClick={() => viewFile(formData.approvingAuthoritySignatureUrl)}
        style={{ background: "none", border: "none", padding: 0, color: "#06c", cursor: "pointer", textDecoration: "underline" }}
      >
        View
      </button>
    </p>
  )}
              {fieldErrors.approvingAuthoritySignature && (
                <span
                  className="error-tooltip"
                  id="approvingAuthoritySignature-error"
                  role="alert"
                >
                  {fieldErrors.approvingAuthoritySignature}
                </span>
              )}
            </div>


            <div className="form-group">
              <label htmlFor="declaration">
                <input
                  id="declaration"
                  type="checkbox"
                  name="declaration"
                  checked={formData.declaration}
                  onChange={(e) => handleChange('declaration', e.target.checked)}
                  className="form-checkbox"
                  aria-required="true"
                />
                I declare that the information submitted is true and complete.
              </label>
              {fieldErrors.declaration && (
                <span id="declaration-error" className="error-tooltip" role="alert">
                  {fieldErrors.declaration}
                </span>
              )}

            </div>
          </div>
        )}
      </div>
    );
  };
  useEffect(() => {
    const middlePosition = window.innerHeight / 2; // middle
    window.scrollTo({ top: middlePosition + 100, behavior: 'smooth' }); 
}, [currentStep]);

const navigate = useNavigate();
  return (
    <div className="sidebar-guideline-container">
      <SidebarGuideline
        isOpen={true}
        sidebarItems={[{ id: 'Guideline', label: 'Guideline' }]}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        selectedAwardCategory={formData.category}
      />
      <div className="application-form">
        <div className="form-header">
          <h1>{awardTitle}</h1>
          <h6>Step {currentStep} of 5</h6>
        </div>
        {error && (
          <div className="error" role="alert">
            {error}
          </div>
        )}
        {isSubmitted ? (
          <div className="thank-you-message">
            <h2>Thank you for your submission!</h2>
            <p>Your registration has been successfully submitted.</p>
           <button onClick={() => navigate('/#Award%20Categories')}>
  Submit Another Application
</button>
             
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {renderStepContent()}
            {currentStep === 1 && (
              <div className="form-navigation-step1">
                <button
                                  type="button"
                                  onClick={handleSaveDraft}
                                  className="btn btn-outline"
                                  disabled={isSubmited()}
                                >
                                  <Save size={16} /> Save Draft
                                </button>
                <button
                  type="button"
                  onClick={nextStep}
                  className="btn btn-primary"
                  disabled={fieldErrors.Organisationname?.includes('Maximum limit')}
                >
                  Next <ChevronRight size={16} />
                </button>
              </div>
            )}
            {currentStep > 1 && (
              <div className="form-navigation">
                <button type="button" onClick={prevStep} className="btn btn-outline">
                  <ChevronLeft size={16} /> Previous
                </button>
                <button
                                  type="button"
                                  onClick={handleSaveDraft}
                                  className="btn btn-outline"
                                  disabled={isSubmited()}
                                >
                                  <Save size={16} /> Save Draft
                                </button>
                {currentStep < 5 && (
                  <button type="button" onClick={nextStep} className="btn btn-primary">
                    Next <ChevronRight size={16} />
                  </button>
                )}
                             {currentStep === 5 && (
                <button
                    type="button"
                    className="btn btn-success"
                    disabled={isSubmited()}
                    onClick={(e) => {
                      if (!formData.declaration) {
                        return alert(
                          "Please accept the declaration before submitting."
                        );
                      }
                      if (!formData.approvingAuthoritySignature) {
                        return alert(
                          "Please upload the approving authority signature file."
                        );
                      }
                      if (!window.confirm("Are you sure you want to submit?")) {
                        e.preventDefault();

                    }
                    alert("Innovator registration submitted successfully!");
                    setIsSubmitted(true);

                      handleSubmit(e, "submit");
                    }}
                  >
                    Submit
                  </button>
                )}
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
};

export default RegistrationInnovator;